module.exports = __webpack_public_path__ + "static/about-us-6bef5687e6435b075e4ae050cc1f2d6b.png";